import React, { useCallback, useReducer} from "react";

import ConexContext from "./ConexContext";
import ConexReducer from "./ConexReducer";

const ConexState = (props) => {
	const initialState = {
		//token: null,
		tipo_usuario: null,
		id_usuario: null,
		codigo_entidad: null,
		departamento: null,
		nif_usuario: null,
	};
	const [state, dispatch] = useReducer(ConexReducer, {initialState});
	const config = require('../config/config.json');

	const setToken = (token) => {
		dispatch({ type: 'SET_JWT', payload: token});
	}
	/**
	* lanza una peticion al microservicio
	* @param {string} url 
	*/
	const getToken= useCallback(()=>{
		return localStorage?.token?? null
	},[])

	const peticion = useCallback(async (url, {method='GET', headers={}, json=null}={})=>{
		if (json & method==='GET')
			return({
				mensaje:"Imposible mandar JSON con el método GET",
				estado:3
			})
		let data
		try{
			let conexBack=config.conexBack
			let host=conexBack.host;
			let param={
				method: method,
				headers: headers
			}
			param.headers.authorization=getToken()

			if (json){
				param.headers['Content-Type']='application/json'
				param['body']=JSON.stringify(json)
			}
			if (conexBack?.port??null) //si el puerto es 0 no se usa
				host+=':'+conexBack.port
			data= await fetch(`${host}/${conexBack.app}/${conexBack.version}${url}`,param);
		}
		catch {
			return({
				mensaje:"El microservicio no responde",
				estado:1
			})
		}
		if (data.status!==200)
			return({
				mensaje:`Problema de conexión. ${data.status}. ${data.statusText}. ${data.type}`,
				estado:2
			})
		data= await data.json();
		data.peticion=url

		if ('token' in data)// si hay un token automáticamente lo guardo
			dispatch({ type: 'SET_JWT', payload: data.token});
		if (config.conexBack.debugMode)
			console.log(data)
		return (data)
	},[config.conexBack,getToken])


    return (
		<ConexContext.Provider
			value={{
				peticion,
				setToken,
				getToken,
				tipo_usuario: state.tipo_usuario,
				id_usuario: state.id_usuario,
				codigo_entidad: state.codigo_entidad,
				departamento: state.departamento,
				nif_usuario: state.nif_usuario
			}}
		>
			{props.children}
		</ConexContext.Provider>
	);
};

export default ConexState;